import Common from "../../Utility/Common";
const ChangePassword = () => ({
    email: Common.Email(),
    password: '',
    confirmPassword: '',
    token: Common.Token(),
    currentPassword: ''
})
export default ChangePassword;